import styled from "styled-components";

export const Scroll = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 12px 14px 16px;
  background: #fafbfb;
`;

export const FlavorList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ObsSection = styled.div`
  margin-top: 14px;
`;

export const ObsLabel = styled.div`
  font-weight: 800;
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
  margin-bottom: 7px;
`;

export const ObsHint = styled.span`
  font-weight: 600;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const Textarea = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  resize: none;
  border: 1.5px solid ${(p) => p.theme.tokens.colors.inputBorder};
  border-radius: 14px;
  padding: 11px 13px;
  font-size: 13.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  color: ${(p) => p.theme.tokens.colors.ink};
  outline: none;
  background: ${(p) => p.theme.tokens.colors.surface};
`;

export const OptionsCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 16px;
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  padding: 4px 14px;
`;

export const ChoiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const ExtrasIntro = styled.div`
  font-weight: 700;
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.muted};
  padding: 0 2px 10px;
`;

export const FlavourCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 16px;
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  overflow: hidden;

  & + & {
    margin-top: 10px;
  }
`;

export const FlavourCardHead = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const FlavourCardTitle = styled.div`
  flex: 1;
  min-width: 0;
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const FlavourCardMeta = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const FlavourCardBody = styled.div`
  padding: 2px 14px 8px;
`;

export const FlavourCardEmpty = styled.div`
  padding: 8px 14px 14px;
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

export const Footer = styled.div`
  padding: 12px 16px calc(0px + env(safe-area-inset-bottom));
  border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  flex-shrink: 0;
`;

export const ConfirmButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  border: none;
  cursor: ${(p) => (p.disabled ? "default" : "pointer")};
  border-radius: 16px;
  padding: 16px 22px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: 16.5px;
  color: #fff;
  background: ${(p) => (p.disabled ? p.theme.tokens.colors.disabledBg : p.theme.tokens.gradients.accent)};
  box-shadow: ${(p) => (p.disabled ? "none" : p.theme.tokens.shadows.ctaAccent)};
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 16px 0 8px;
`;

export const SummaryCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.bg};
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  border-radius: 14px;
  padding: 10px 14px;
  margin-bottom: 4px;
`;

export const SummaryLine = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13.5px;
  font-weight: 700;
  color: ${(p) => p.theme.tokens.colors.ink};
  padding: 3px 0;
`;

export const EditButton = styled.button`
  border: none;
  background: none;
  padding: 8px 4px;
  font-size: 13px;
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.teal};
  cursor: pointer;
`;
